import { NEW_FIELD_PREFIX } from "../type";

export const isSavedFormField = (id: string | null | undefined): boolean => {
    return !id?.includes(NEW_FIELD_PREFIX);
};
